<div (click)="handleClick()">
  <div class="due-date" *ngIf="projectActivity">
    <div style="flex: 1;">{{projectActivity.startDate | date: 'MMM d, y h:mm a'}}</div>
    <div class="delivery-instructions" *ngIf="deliveryInstructions"
         pTooltip="{{deliveryInstructions}}"
         tooltipPosition="bottom">
      <i class="pi pi-exclamation-triangle" style="font-size: 100%; height: 10px;"></i>
    </div>
    <div class="date-code" pTooltip="{{dateFullCode}}" tooltipPosition="bottom">{{dateCode}}</div>
  </div>
  <div class="due-date" *ngIf="!projectActivity && !isTypeNone()">Choose Date</div>
  <div class="due-date" *ngIf="!projectActivity && isTypeNone()">Choose Type</div>
</div>
